// Either the customer asked for an appointment at booking, or the carrier has
// already set one. In both cases the carrier arranges the delivery time with
// the consignee, so the delivery location's hours don't apply.
export function shipmentIsDeliveringByAppointment(shipment: {
  appointmentDate?: string | undefined;
  deliveryLocation: { accessorials: Array<string> };
}): boolean {
  return (
    shipment.deliveryLocation.accessorials.includes(
      "SCHEDULING_APPOINTMENT_REQUIRED",
    ) || shipment.appointmentDate !== undefined
  );
}
